import validBarcode from 'barcode-validator';

/**
 * @param {String} ean
 * @return {Boolean}
 */
export function isValidEan(ean) {
    return validBarcode(ean);
}
